import { useMemo } from 'react';

import { User as Auth0User, useAuth0 } from '@auth0/auth0-react';

import { ActorRole } from '../lib/graphql/generated/graphql';

// Internal engineers. Used as a feature whitelist (Versions, ReopenNegotiation)
// and surfaced to analytics as the `isDeveloper` user property.
const DEVELOPER_EMAILS = [
  'alexandre.c@appchoose.io',
  'arnaud@appchoose.io',
  'enzo.viala@appchoose.io',
  'manu@appchoose.io',
  'severin@appchoose.io',
  'thibaut@appchoose.io',
  'daniel.osokin@appchoose.io',
];

export interface User {
  providerUser: Auth0User;
  isInternalUser: boolean;
  isDeveloper: boolean;
  role: ActorRole;
  canAccessVersions: boolean;
  canReopenNegotiation: boolean;
}

export const composeUser = (user: Auth0User): User => {
  const isInternalUser = user?.['https://appchoose.io/claims/isInternalUser'];
  const isDeveloper = user.email
    ? DEVELOPER_EMAILS.includes(user.email)
    : false;
  return {
    providerUser: user,
    isInternalUser,
    isDeveloper,
    role: isInternalUser ? ActorRole.Choose : ActorRole.Brand,
    canAccessVersions: isDeveloper,
    canReopenNegotiation: isInternalUser,
  };
};
export function useUser(): User | undefined {
  const { user } = useAuth0();
  return useMemo(() => {
    if (!user) return undefined;
    return composeUser(user);
  }, [user]);
}
